<template>
  <div style="padding: 20px;">
    <!-- 搜索条件 -->
    <div class="search-area">
      <el-select v-model="params.department_id" filterable placeholder="请选择部门" clearable @change="handleDepartmentChange">
        <el-option v-for="item in departmentOptions" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>

      <el-select
        v-model="params.pitcher_id"
        :disabled="!params.department_id"
        filterable
        placeholder="请选择投手"
        style="margin-left: 20px;"
        clearable
      >
        <el-option v-for="item in pitcherOptions" :key="item.id" :label="item.admin_name" :value="item.id" />
      </el-select>

      <el-select
        v-model="params.position_id"
        filterable
        placeholder="请选择投放位置"
        style="margin-left: 20px;"
        clearable
      >
        <el-option v-for="item in positionOptions" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>

      <el-date-picker
        v-model="dateRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 300px;margin-left: 20px;"
        @change="handleDateChange"
      />

      <el-input v-model="params.account_id" placeholder="广告主ID" style="width: 200px;margin-left: 20px;" />

      <el-button type="primary" icon="el-icon-search" style="margin-left: 20px;" @click="handleSearch">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
    </div>

    <!-- Tabs 切换 -->
    <el-tabs v-model="activeTab" style="margin-top: 20px;" @tab-click="handleTabClick">
      <el-tab-pane label="账户报表" name="account">
        <account-report-table
          :key="`account-${tableKey}`"
          :loading="loading"
          :table-data="tableData"
          :params="params"
          @refresh="getDataList"
          @update:orderBy="handleOrderByChange"
        />
      </el-tab-pane>
      <el-tab-pane label="项目报表" name="project">
        <project-report-table
          :key="`project-${tableKey}`"
          :loading="loading"
          :table-data="tableData"
          :params="params"
          @refresh="getDataList"
          @update:orderBy="handleOrderByChange"
        />
      </el-tab-pane>
      <el-tab-pane label="推广单元报表" name="promotion">
        <promotion-report-table
          :key="`promotion-${tableKey}`"
          :loading="loading"
          :table-data="tableData"
          :params="params"
          @refresh="getDataList"
          @update:orderBy="handleOrderByChange"
        />
      </el-tab-pane>
    </el-tabs>

    <!-- 分页 -->
    <pagination-right
      :total="total"
      :current-page="params.page"
      :page-size="params.page_size"
      :page-sizes="[10, 20, 50, 100]"
      @size-change="handlePageSizeChange"
      @current-change="handlePageChange"
    />
  </div>
</template>

<script>
import { accountReportList, projectReportList, promotionReportList, iaaMaterialReportdepartmentlist, iaapitcherindex } from '@/api/TKreleaseGroup.js'
import { placementList } from '@/api/notify.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import AccountReportTable from './components/AccountReportTable.vue'
import ProjectReportTable from './components/ProjectReportTable.vue'
import PromotionReportTable from './components/PromotionReportTable.vue'

export default {
  name: 'MassiveReport',
  components: {
    PaginationRight,
    AccountReportTable,
    ProjectReportTable,
    PromotionReportTable
  },
  data() {
    // 获取当天日期
    const today = new Date()
    const todayStr = today.toISOString().split('T')[0]

    return {
      activeTab: 'account',
      loading: false,
      dateRange: [todayStr, todayStr],
      departmentOptions: [],
      pitcherOptions: [],
      positionOptions: [],
      tableData: [],
      total: 0,
      tableKey: 0, // 用于强制重新渲染表格组件，重置排序状态
      params: {
        page: 1,
        page_size: 10,
        begin_time: todayStr,
        end_time: todayStr,
        account_id: '',
        pitcher_id: '',
        position_id: '',
        department_id: '',
        order_by: null
      }
    }
  },
  created() {
    this.getDepartmentList()
    this.getPositionList()
    this.getDataList()
  },
  methods: {
    // 获取部门列表
    getDepartmentList() {
      iaaMaterialReportdepartmentlist({ page: 1, page_size: 100 }).then((res) => {
        this.departmentOptions = res.data.list || []
      })
    },
    // 获取投手列表
    getPitcherList() {
      if (!this.params.department_id) {
        this.pitcherOptions = []
        return
      }
      iaapitcherindex({ page: 1, page_size: 100, department_id: this.params.department_id }).then((res) => {
        this.pitcherOptions = res.data.list || []
      })
    },
    // 获取投放位置列表
    getPositionList() {
      placementList({ page: 1, page_size: 100 }).then((res) => {
        this.positionOptions = res.data.list || []
      })
    },
    // 部门变化
    handleDepartmentChange() {
      this.params.pitcher_id = ''
      this.getPitcherList()
    },
    // 日期变化
    handleDateChange(val) {
      if (val && val.length === 2) {
        this.params.begin_time = val[0]
        this.params.end_time = val[1]
      } else {
        this.params.begin_time = ''
        this.params.end_time = ''
      }
    },
    // Tab 切换
    handleTabClick(tab) {
      // 保存当前日期
      const currentBeginTime = this.params.begin_time
      const currentEndTime = this.params.end_time
      const currentDateRange = this.dateRange

      // 清空搜索项和排序，但保留日期
      this.params.account_id = ''
      this.params.pitcher_id = ''
      this.params.position_id = ''
      this.params.department_id = ''
      this.params.order_by = null
      this.pitcherOptions = []

      // 更新 tableKey 以强制重新渲染表格组件，重置排序状态
      this.tableKey += 1

      // 恢复日期（如果日期为空，则设置为当天）
      if (!currentBeginTime || !currentEndTime || !currentDateRange || currentDateRange.length !== 2) {
        const today = new Date()
        const todayStr = today.toISOString().split('T')[0]
        this.params.begin_time = todayStr
        this.params.end_time = todayStr
        this.dateRange = [todayStr, todayStr]
      } else {
        this.params.begin_time = currentBeginTime
        this.params.end_time = currentEndTime
        this.dateRange = currentDateRange
      }

      this.params.page = 1
      this.getDataList()
    },
    // 搜索
    handleSearch() {
      this.params.page = 1
      this.getDataList()
    },
    // 重置
    handleReset() {
      // 获取当天日期
      const today = new Date()
      const todayStr = today.toISOString().split('T')[0]

      this.dateRange = [todayStr, todayStr]
      this.params = {
        page: 1,
        page_size: 10,
        begin_time: todayStr,
        end_time: todayStr,
        account_id: '',
        pitcher_id: '',
        position_id: '',
        department_id: '',
        order_by: null
      }
      this.pitcherOptions = []
      this.getDataList()
    },
    // 获取数据列表
    getDataList() {
      this.loading = true
      const apiMap = {
        account: accountReportList,
        project: projectReportList,
        promotion: promotionReportList
      }
      const api = apiMap[this.activeTab]
      if (!api) {
        this.loading = false
        return
      }

      // 构建请求参数
      const requestParams = {
        page: this.params.page,
        page_size: this.params.page_size
      }

      // 添加可选参数
      if (this.params.begin_time) requestParams.begin_time = this.params.begin_time
      if (this.params.end_time) requestParams.end_time = this.params.end_time
      if (this.params.account_id) requestParams.account_id = this.params.account_id
      if (this.params.pitcher_id) requestParams.pitcher_id = this.params.pitcher_id
      if (this.params.position_id) requestParams.position_id = this.params.position_id
      if (this.params.order_by) requestParams.order_by = typeof this.params.order_by === 'string' ? this.params.order_by : JSON.stringify(this.params.order_by)

      api(requestParams).then((res) => {
        this.tableData = res.data.list || []
        this.total = res.data.count || res.data.total || 0
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.total = 0
        this.loading = false
      })
    },
    // 分页大小变化
    handlePageSizeChange(size) {
      this.params.page_size = size
      this.params.page = 1
      this.getDataList()
    },
    // 页码变化
    handlePageChange(page) {
      this.params.page = page
      this.getDataList()
    },
    // 排序变化
    handleOrderByChange(orderBy) {
      this.params.order_by = orderBy
      this.params.page = 1
      this.getDataList()
    }
  }
}
</script>

<style scoped>
.search-area {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
</style>
